import * as React from "react";
const SvgFiRrBookHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10.53 13.465c.426.349.948.522 1.47.522s1.044-.174 1.47-.523C15.08 12.145 17 10.163 17 8.218 17 6.444 15.654 5 14 5c-.782 0-1.477.27-2 .727A3 3 0 0 0 10 5C8.346 5 7 6.444 7 8.218c0 1.944 1.92 3.926 3.53 5.247M10 7c.483 0 1 .263 1 1a1 1 0 0 0 2 0c0-.737.517-1 1-1 .551 0 1 .546 1 1.218 0 .867-1.072 2.285-2.798 3.699a.32.32 0 0 1-.404 0C10.072 10.502 9 9.085 9 8.218 9 7.546 9.449 7 10 7m7-7H7C4.243 0 2 2.243 2 5v15c0 2.206 1.794 4 4 4h11c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M7 2h10c1.654 0 3 1.346 3 3v11H6c-.732 0-1.409.212-2 .556V5c0-1.654 1.346-3 3-3m10 20H6c-1.103 0-2-.897-2-2s.897-2 2-2h14v1c0 1.654-1.346 3-3 3"
    />
  </svg>
);
export default SvgFiRrBookHeart;
